import { render, staticRenderFns } from "./VerificationField.vue?vue&type=template&id=4106dca7&scoped=true&"
import script from "./VerificationField.vue?vue&type=script&lang=js&"
export * from "./VerificationField.vue?vue&type=script&lang=js&"
import style0 from "./VerificationField.vue?vue&type=style&index=0&id=4106dca7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4106dca7",
  null
  
)

export default component.exports